import React, { useState } from 'react';
import UploaderSection from '../UploaderSection';
import { CallbackFunction } from '../exportAndDownload';
import { useAllowNavigate } from '../useAllowNavigate';
import styles from '../../FullTextBulkUploader.module.css';
import { Button, Text, Loading, Icon, IconList } from 'components/core';
import { Inline } from 'components/layout';

type downloadState = 'not-started' | 'in-progress' | 'failure' | 'successful';

type ReferenceManagerFileExporterProps = {
  // Sets the window to warn users before navigating
  downloadStudies: (callback: CallbackFunction) => void;
  setErrorMessage: (message: string) => void;
};

const buttonContent = (inProgress: boolean) => {
  return inProgress ? (
    <Loading />
  ) : (
    <Inline component="span" spacing={2}>
      <Icon icon={IconList.light.faCloudDownload} size="md" />
      Download studies
    </Inline>
  );
};

const ReferenceManagerFileExporter = (
  props: ReferenceManagerFileExporterProps
) => {
  const { downloadStudies, setErrorMessage } = props;

  const { setAllowNavigate } = useAllowNavigate(true);
  const [
    currentDownloadState,
    setCurrentDownloadState,
  ] = useState<downloadState>('not-started');

  const inProgress = currentDownloadState === 'in-progress';

  return (
    <UploaderSection error={currentDownloadState === 'failure'}>
      <Text className={styles.StepText}>
        Step 1: Download studies missing full text
      </Text>
      <Button
        className={styles.StepAction}
        variant="outline"
        role="link"
        onClick={() => {
          setAllowNavigate(false);
          setCurrentDownloadState('in-progress');
          downloadStudies((result) => {
            setAllowNavigate(true);
            if (result.status === 'success') {
              setCurrentDownloadState('not-started');
            }
            if (result.status === 'failure') {
              setCurrentDownloadState('failure');
              setErrorMessage(result.message);
            }
          });
        }}
        disabled={inProgress}
      >
        {buttonContent(inProgress)}
      </Button>
    </UploaderSection>
  );
};

export default ReferenceManagerFileExporter;
